import React, { useState ,useEffect} from 'react'
import Corpnavbar  from '../Components/Corpnavbar';
import Corpsidebar  from '../Components/Corpsidebar';
import CorpProfilemain from '../Components/CorpProfilemain';
import {Link} from 'react-router-dom';

const CorpProfile = () => {
    const[sidebar,setSidebarOpen]= useState(false);

    const togglesidebar = ()=> {
      setSidebarOpen((prevState) => !prevState);
    }

    
  
    useEffect(()=>{const venture = localStorage.getItem('ventureid');

    let CORPcheck = venture.includes('05')
     


  if(CORPcheck==true){
    document.getElementById("Corp-dashboard").style.display="grid"
  }
  else{
    document.getElementById("Corp-dashboard").style.display="none"
  
}
     
    },[]);


    /*---Once logout then clear localstorage function----*/

    function removelocalstorage(){
      localStorage.clear()
      window.location.href='/'
    }

    
/*----Logout form function----*/


    function ToggleLogForm()
    {
       document.getElementById("modalLogoutForm").style.display = "block";
    }
    
    
     
    function closeForm()
    {
       document.getElementById("modalLogoutForm").style.display = "none";
     
     }



  return (
  
       <div className="corp-container" id="Corp-dashboard">
    <Corpnavbar sidebar={sidebar} openSidebar={togglesidebar}/>
   <Corpsidebar sidebar={sidebar} openLogForm={ToggleLogForm} />
   <CorpProfilemain/>

   
   <div className="Paropop-fade" id="modalLogoutForm" tabindex="-1" role="dialog">
  <div className="modal-dialog" role="document" id="Corpcenterlogoutform">
    <div className="modal-content">
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">LOG OUT</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

<form id='form'>

   <div className="modal-body mx-3">

        <div className="md-form mb-5">
            <div className='text-center'>
          <h5>Are you sure want to logout?</h5>
          </div>
        </div>

   </div>

      <div className="modal-footer d-flex justify-content-center">
        <Link to="/"><button className="Corp-logout-button" onClick={removelocalstorage} type='submit'>Confirm</button></Link>
        <button className="Corp-logout-button" onClick={closeForm} type='submit'>Cancel</button>
      </div>

      </form>
      
    </div>
  </div>
</div>

 
 </div>
  )
}

export default CorpProfile
